// extracted by mini-css-extract-plugin
export default {"SchedulerViewWrapper":"SchedulerViewWrapper_SchedulerViewWrapper__mg3SV"};